module.exports = __webpack_public_path__ + "media/PAG60-02.12bf4eb9.mp3";